/* ==========================================================================
   ABO TALEB — cart drawer
   Adding to the cart opens a panel instead of leaving the page. Every add
   form on the site is intercepted, so a shopper never loses their place.
   If this file fails to load the forms still post normally to /cart.
   ========================================================================== */
(function () {
  'use strict';

  var script = document.currentScript ||
    document.querySelector('script[src*="abo-cart"]');
  var MONEY = (script && script.getAttribute('data-money-format')) || 'LE {{amount}}';
  var CART_URL = (script && script.getAttribute('data-cart-url')) || '/cart';
  var ALL_URL = (script && script.getAttribute('data-all-url')) || '/collections/all';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var drawer, body, foot, totalEl, countEl;
  var busy = false;

  /* ---------- money ------------------------------------------------------
     Shopify hands the cart back in cents and leaves formatting to the theme,
     so the shop's own money format string is applied here.                 */
  function money(cents) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function num(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(n) || n === null) return '0';
      var fixed = (n / 100.0).toFixed(precision);
      var parts = fixed.split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return head + (parts[1] ? decimal + parts[1] : '');
    }
    var match = MONEY.match(placeholder);
    var value;
    switch (match && match[1]) {
      case 'amount_no_decimals': value = num(cents, 0); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ','); break;
      default: value = num(cents, 2);
    }
    return MONEY.replace(placeholder, value);
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ---------- open / close ------------------------------------------------ */
  function open() {
    if (!drawer) return;
    drawer.hidden = false;
    /* One frame between unhiding and animating, or the transition is skipped. */
    window.requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    var closer = drawer.querySelector('[data-at-cart-close]');
    if (closer && closer.focus) closer.focus();
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    window.setTimeout(function () {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 380);
  }

  /* ---------- render ------------------------------------------------------ */
  function render(cart) {
    if (!drawer || !cart) return;
    if (countEl) countEl.textContent = cart.item_count;

    /* The header's own counter mirrors the drawer. */
    document.querySelectorAll('.at-cart-count').forEach(function (el) {
      el.textContent = '(' + cart.item_count + ')';
    });

    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<div class="at-cd-empty">السلة فاضية.<br><br>' +
        '<a href="' + esc(ALL_URL) + '">شوف المنتجات</a></div>';
      foot.hidden = true;
      return;
    }

    var html = '';
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var src = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      var img = src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '';
      /* "Default Title" is Shopify's placeholder for a single-variant product. */
      var opts = (item.options_with_values || [])
        .filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return esc(o.value); })
        .join(' · ');

      html += '<div class="at-cd-line" data-line="' + (i + 1) + '">' +
        '<div class="at-cd-media">' + img + '</div>' +
        '<div>' +
          '<div class="at-cd-name">' + esc(item.product_title) + '</div>' +
          (opts ? '<div class="at-cd-opts">' + opts + '</div>' : '') +
          '<div class="at-cd-lfoot">' +
            '<div class="at-cd-qty">' +
              '<button type="button" data-at-line-step="up" aria-label="زيادة">+</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-at-line-step="down" aria-label="تقليل">−</button>' +
            '</div>' +
            '<span class="at-cd-price">' + money(item.line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="at-cd-remove" data-at-line-remove>شيل</button>' +
        '</div>' +
      '</div>';
    }

    body.innerHTML = html;
    totalEl.textContent = money(cart.total_price);
    foot.hidden = false;
  }

  function refresh() {
    return fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; });
  }

  function setBusy(on) {
    busy = on;
    if (drawer) drawer.classList.toggle('is-busy', on);
  }

  function changeLine(line, quantity) {
    if (busy) return;
    setBusy(true);
    fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { window.location.href = CART_URL; })
      .then(function () { setBusy(false); });
  }

  /* ---------- add to cart -------------------------------------------------
     The buy-now button posts the same form with a return_to of the checkout,
     so it flags itself and is left alone here.                             */
  function onSubmit(e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (form.querySelector('input[name="return_to"]')) return;

    e.preventDefault();
    if (busy) return;
    setBusy(true);

    var trigger = form.querySelector('[data-at-add]');
    var textEl = trigger && trigger.querySelector('[data-at-add-text]');
    var restore = textEl ? textEl.textContent : null;
    if (trigger) trigger.disabled = true;
    if (textEl) textEl.textContent = 'ثواني...';

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return refresh();
      })
      .then(open)
      .catch(function () { form.submit(); })
      .then(function () {
        setBusy(false);
        if (trigger) trigger.disabled = false;
        if (textEl && restore !== null) textEl.textContent = restore;
      });
  }

  /* ---------- wiring ------------------------------------------------------ */
  function boot() {
    drawer = document.querySelector('[data-at-cart]');
    if (!drawer) return;
    body = drawer.querySelector('[data-at-cart-body]');
    foot = drawer.querySelector('[data-at-cart-foot]');
    totalEl = drawer.querySelector('[data-at-cart-total]');
    countEl = drawer.querySelector('[data-at-cart-count]');

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-at-cart-close]')) { close(); return; }

      var line = e.target.closest('[data-line]');
      if (!line) return;
      var index = parseInt(line.getAttribute('data-line'), 10);
      var counter = line.querySelector('.at-cd-qty span');
      var qty = counter ? (parseInt(counter.textContent, 10) || 1) : 1;

      if (e.target.closest('[data-at-line-remove]')) { changeLine(index, 0); return; }
      var step = e.target.closest('[data-at-line-step]');
      if (!step) return;
      var dir = step.getAttribute('data-at-line-step') === 'up' ? 1 : -1;
      changeLine(index, Math.max(0, qty + dir));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    /* Any link to the cart opens the panel instead of navigating. */
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-at-cart-open], a.at-cart');
      if (!link) return;
      e.preventDefault();
      refresh().then(open);
    });

    document.addEventListener('submit', onSubmit);

    /* Fill the counter on load without opening anything. */
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
